import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AuthService} from '../../../core/services/auth.service';
import {Router, RouterLink} from '@angular/router';
import {StorageService} from '../../../core/services/storage.service';
import {RETURN_URL} from '../../../app.config';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommunicationService} from '../../../core/services/communication.service';
import {Subscription} from 'rxjs';
import {NgClass} from '@angular/common';
import {CurrentUserService} from '../../../core/services/user.service';
import {UserPermissionsService} from '../../../core/services/user-permissions.service';
import {UserTableSettingsService} from '../../../core/services/user-table-settings.service';


@Component({
    selector: 'ostso-login',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, MatCheckboxModule, ReactiveFormsModule, NgClass, RouterLink],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
    subscription: Subscription = new Subscription();
    isLoading = false;

    form: FormGroup = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        modePass: [false],
    });

    constructor(
        private auth: AuthService,
        private user: CurrentUserService,
        private router: Router,
        private storage: StorageService,
        public fb: FormBuilder,
        private commutator: CommunicationService,
        @Inject(RETURN_URL) private returnURL: string,
        private permissionsService: UserPermissionsService,
        private userTableSettingsService: UserTableSettingsService
    ) {
    }

    login(): void {
        if (!this.form.get('email')!.value || !this.form.get('password')!.value) return this.commutator.publish('Не введены данные для входа', {type: 'error'});
        this.isLoading = true;
        const connect = this.auth.login(this.form.get('email')!.value, this.form.get('password')!.value)
            .subscribe({
                    next: async (v: any) => {
                        console.log('login', v);
                        if (v === 'Empty token' || v?.status === 401) {
                            this.isLoading = false;
                            setTimeout(() => {
                                this.form.get('email')!.setValue('');
                                this.form.get('password')!.setValue('');
                            }, this.commutator.duration);
                            return this.commutator.error('Неправильный логин или пароль');
                        }
                        this.permissionsService.setPermissions(v?.user?.rights)
                        this.userTableSettingsService.init();
                        await this.router.navigate([this.storage.getItem(this.returnURL) || '/grade']);
                    },
                    error: (err) => {
                        this.commutator.publish(err);
                    },
                }
            );
        this.subscription.add(connect);
    }

    ngOnInit(): void {
        if (this.router.url.includes('/logout')) {
            return this.auth.logout();
        }
        this.user.isEmpty && this.user.fetchUser();
        this.auth.isLoggedIn && !this.user.isEmpty && this.router.navigate([this.storage.getItem(this.returnURL) || '/index-entity']);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
